export const QLD_MODELS = {
  MODEL_1: 'Model 1',
  MODEL_2: 'Model 2',
  MODEL_3: 'Model 3',
};

export const DEFAULT_MODELS_TO_HIDE = [QLD_MODELS.MODEL_1];

const envValue = process.env.VUE_APP_COMPLIANCE_MODELS_HIDE;

export const MODELS_TO_HIDE = envValue
  ? envValue
      .split(',')
      .map(v => v.trim())
      .filter(Boolean)
  : DEFAULT_MODELS_TO_HIDE;